import { configureStore } from "@reduxjs/toolkit";
import {
  /*initialReducer,
  initialScoreReducer,
  linesReducer,*/
  staticReducer,
  initialState,
} from "./reducers/reducers";

const store = configureStore({
  reducer: {
    /*initialScore: initialScoreReducer,
    initial: initialReducer,
    lines: linesReducer,*/
    static: staticReducer,
  },
  preloadedState: initialState,
});

export default store;
